<template>
  <router-link
    :to="{ name: 'v2_pages_profile' }"
    class="d-flex align-items-center dropdown-user-link text-decoration-none"
  >
    <b-avatar
      size="40"
      :src="require('@/assets/images/avatars/AvatarImage.png')"
      variant="light-primary"
      badge
      class="badge-minimal"
      badge-variant="success"
    >
      <!-- <feather-icon
        v-if="!userData.fullName"
        icon="UserIcon"
        size="22"
      /> -->
    </b-avatar>
    <div class="d-sm-flex d-none user-nav flex-column ml-1">
      <p class="user-name font-weight-bolder mb-0" v-if="title">
        {{ title }}
      </p>
      <p class="user-name font-weight-bolder mb-0" v-else>
        Asia Emad
      </p>
      <span v-if="subtitle">{{ subtitle }}</span>
      <span v-else>AUC</span>
    </div>
  </router-link>
</template>

<script>
import {
  BAvatar,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BAvatar,
  },
  props:{
    title: String,
    subtitle: String,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      avatarText,
    }
  },
}
</script>
